import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('collaboration-sidebar', {
  library: 'collaboration-sidebar'
});